import { UserType } from '@types';
import { UserApiType } from '@api/types';
import dayjs from 'dayjs';

export const toDateJsDatePicker = (dateApi: string) => {
  return dayjs(dateApi).startOf('day');
};
export const userApiMapper = (user: UserApiType): UserType => {
  try {
    return {
      idUser: user.idUser,
      email: user.email,
      phone: user?.phone,
      address: user?.address,
      firstName: user?.firstName,
      lastName: user?.lastName,
      urlAvatar: user?.urlAvatar,
      creationDate: user?.creationDate,
      nationality: user?.nationality,
      earning: user?.earning,
      study: user?.study,
      family: user?.family,
      children: user?.children,
      job: user?.job,
      activitySector: user?.activitySector,
      birthDate: user?.birthDate && toDateJsDatePicker(user?.birthDate),
    };
  } catch (e) {
    throw e;
  }
};
